import { render } from "./AdminOverview.vue?vue&type=template&id=3e758c42"
import script from "./AdminOverview.vue?vue&type=script&lang=js"
export * from "./AdminOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__